import { USERS_LISTING } from "../../helpers/url_helper"
import { baseApi } from "./index";

export const usersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: ({ limit = 10, orderBy = "createdAt", order = "asc" }) => {
        const query = new URLSearchParams({
          limit,
          orderBy,
          sortBy: order
        });
        const queryString = query.toString();
        return `${USERS_LISTING}?${queryString}`
      },
      transformResponse: (response) => response.data,
    }),
  }),
})

export const {
  useGetUsersQuery
} = usersApi